import React from 'react';

export function Divider ({
  label
} : {
  label: string
}) {
  return (
    <div className="mt-8 mb-4">
      <hr className="border-gray-300" />
      {label ? (
        <div className="w-full text-center text-xl text-gray-400 mt-[-17]">
          <span className="bg-white px-2">{label}</span>
        </div>
      ) : null}
    </div>
  );
}
